import styled from "@emotion/styled";
import {
  COLOR_DIVIDER,
  COLOR_TERTIARY,
  MOBILE_SCREEN,
  COLOR_ERROR_COMPONENT_TEXT,
  BOX_SHADOW_SMALL,
} from "../theme";
import IconContainer from "../icons/IconContainer";
import { ParagraphHeaderLarge } from "../typography/Paragraph";

export const CardContainer = styled.div`
  background-color: ${COLOR_TERTIARY};
  border-radius: 16px;
  padding: 48px;
  box-shadow: ${BOX_SHADOW_SMALL};
  ${MOBILE_SCREEN} {
    padding: 24px;
  }

  /* Add data attribute for validation error targeting */
  &[data-validation-error="true"] {
    box-shadow: 0 0 0 1px ${COLOR_ERROR_COMPONENT_TEXT};
  }
`;

export const CardHeaderContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  ${MOBILE_SCREEN} {
    margin-bottom: 16px;
  }
`;

export const CardHR = styled.hr`
  border: 0;
  border-top: 1px solid ${COLOR_DIVIDER};
  margin-bottom: 40px;
  ${MOBILE_SCREEN} {
    margin-bottom: 24px;
  }
`;

interface CardProps {
  children: React.ReactNode;
  header?: {
    title?: string | React.ReactNode;
    icon?: React.ReactNode;
    iconColor?: string;
    hr?: boolean;
    titleRow?: React.ReactNode;
  };
  className?: string;
  isError?: boolean;
  onClick?: () => void;
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragEnd?: (e: React.DragEvent<HTMLDivElement>) => void;
}

export const Card = ({
  children,
  header,
  className,
  onClick,
  draggable,
  onDragStart,
  onDragEnd,
  isError = false,
}: CardProps) => {
  return (
    <CardContainer
      className={className}
      data-validation-error={isError ? "true" : "false"}
      onClick={onClick}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
    >
      {(header?.title ?? header?.icon) && (
        <CardHeaderContainer>
          {header.icon && (
            <IconContainer
              backgroundColor={header.iconColor ?? ""}
              width="48px"
              height="48px"
            >
              {header.icon}
            </IconContainer>
          )}
          {header.title && (
            <ParagraphHeaderLarge>{header.title}</ParagraphHeaderLarge>
          )}
        </CardHeaderContainer>
      )}
      {header?.hr && <CardHR />}
      {header?.titleRow && header.titleRow}
      {children}
    </CardContainer>
  );
};

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
